module.exports = require("ajv/lib/refs/json-schema-draft-04.json");